import AppHeader from "../../layout/AppHeader";
import CallCenter from '../../xpost/views/umov/call.center/CallCenter.vue';
import CallCenterAdd from '../../xpost/views/umov/call.center/CallCenterAdd.vue';

const CallCenterRoutes = [
  {
    path: "/cadastro/atendimento",
    name: "call.center",
    components: {
      header: AppHeader,
      default: CallCenter,
    }
  },
  {
    path: "/cadastro/atendimento/adicionar",
    name: "call.center.add",
    components: {
      header: AppHeader,
      default: CallCenterAdd,
    }
  },
  {
    path: "/cadastro/atendimento/editar/:id",
    name: "call.center.edit",
    components: {
      header: AppHeader,
      default: CallCenterAdd,
    }
  },
]

export default CallCenterRoutes;